import { TabRoute } from 'src/components/CommonV2Components/GenericSideBar/types';

/**
 * Takes in the location from React Router and a collection of tab routes and returns the active route based on the URL.
 */
export const findCurrentTabAndSubtab = ({ location, childRoutes }) => {
  let currentRoute: TabRoute; // The tab route object we return at the end
  let currentSubtab: string; // The selected subtab as a string if applicable
  try {
    const currentParams = new URLSearchParams(location.search);
    const currentTab = currentParams.get('tab');
    currentSubtab = currentParams.get('subtab');

    /**
     * The purpose of the following logic is to map the old Beacon navigation to the new navigation components.
     * For each route object, we create an collection of the subtab values and subtab parent values.
     * The subtab values are the new subtabs per each new Beacon page. i.e. Key Metrics, Product Growth, Waterfall under the Summary sidebar tab.
     * The subtab parents are just the tabs that are used to render page layouts based on the old system. Using the previous example, this would NOT be "Summary" but "Sales".
     * We do 2 different checks: The first tries to determine a match based on tab and subtab values.
     * The second match is a fallback when the sidebar tab does not have child subtabs.
     */
    currentRoute = childRoutes.find((route) => {
      const childSubtabValues = route.childSubtabs.map((subtab) => subtab.value);
      const childSubtabParentTabs = route.childSubtabs.map((subtab) => subtab.parentTab);

      return (
        (childSubtabValues.includes(currentSubtab) && childSubtabParentTabs.includes(currentTab)) ||
        (route.tabMappedFrom === currentTab && route.subtabMappedFrom === currentSubtab)
      );
    });

    if (!currentRoute) {
      throw new Error(`No matching route found currentTab: ${currentTab}, currentSubtab: ${currentSubtab}`);
    }


  } catch (error) {
    [currentRoute] = childRoutes;
    currentSubtab = currentRoute.childSubtabs[0].value;
  }

  return { currentRoute, currentSubtab };
};
